import { render } from "./Claim2_Adm.vue?vue&type=template&id=0d2fd090&scoped=true"
import script from "./Claim2_Adm.vue?vue&type=script&lang=js"
export * from "./Claim2_Adm.vue?vue&type=script&lang=js"

import "./Claim2_Adm.vue?vue&type=style&index=0&id=0d2fd090&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0d2fd090"

export default script